import React from "react";
import { formatDate } from "utils/basic";

import type { DateDisplayProps } from "./DateDisplay.types";
import { getDisplayDate, getHintText } from "./DateDisplay.utils";

const DateDisplay: React.FC<DateDisplayProps> = ({
  dateModified,
  dateCreated,
  mode = "modified",
}) => (
  <span title={getHintText(dateCreated, dateModified) || "Текущая дата"}>
    {formatDate(getDisplayDate(mode, dateModified, dateCreated))}
  </span>
);

export default DateDisplay;
